import './creative-compatibility.scss';

import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';
import { Button, Input, Label } from 'reactstrap';

import { creativeShape, productWithRequirementShape } from '../../prop-types';
import { IMAGE } from '../constants';
import ImageCropperButton from '../ImageCropperButton';

function CreativeCompatibilityActions({
  handleChange,
  resizeAndSetLoading,
  campaignRelatedProducts,
  onSuccess,
  onDeleteCreative,
  isLoading,
  campaignId,
  creative,
  products,
}) {
  const getInputIdForSelection = (productId, accessor) =>
    `${creative.id}.${productId}.${accessor}`;

  const compatibleCreativeActions = (
    <div className="my-n1 d-flex flex-column">
      {products.map(({ id, name, creativeRequirement: { sizeType } }) => {
        const title = `${name} - ${sizeType}`;
        return (
          <div
            key={title}
            title={title}
            className="my-1 text-truncate inline-content"
          >
            <Input
              type="checkbox"
              id={getInputIdForSelection(id, 'productId')}
              name={getInputIdForSelection(id, 'productId')}
              className="form-control form-checkbox checkbox-position-relative"
              onChange={e => handleChange(e, id)}
              checked={creative.productIds.includes(id)}
            />
            <Label
              sm={4}
              check
              for={getInputIdForSelection(id, 'productId')}
              style={{ paddingLeft: '20px' }}
            >
              {name}
            </Label>
            <br />
            <div
              style={{ paddingLeft: '20px' }}
              className="text-muted text-truncate"
            >
              {sizeType}
            </div>
          </div>
        );
      })}
    </div>
  );

  const incompatibleCreativeActions = (
    <div className="my-n1 d-flex flex-column">
      <div className="text-danger">Not compatible</div>
      <ImageCropperButton
        onSuccess={onSuccess}
        onDeleteCreative={onDeleteCreative}
        imageData={creative}
      />
      <Button
        className="mt-2 mr-2 btn-sm"
        outline
        disabled={isLoading}
        color="secondary"
        onClick={resizeAndSetLoading}
      >
        Resize
      </Button>
    </div>
  );

  // if there are compatible products:
  if (products.length) {
    return compatibleCreativeActions;
  }

  // if rendered from campaign header:
  if (campaignRelatedProducts) {
    return creative.fileType === IMAGE
      ? incompatibleCreativeActions
      : 'Resize and crop are only available for images';
  }

  // if rendered from show opportunity:
  return (
    <div className="text-wrap">
      {campaignId
        ? 'To resize and crop please go to campaign view'
        : 'There is no campaign yet'}
    </div>
  );
}

CreativeCompatibilityActions.propTypes = {
  handleChange: func.isRequired,
  resizeAndSetLoading: func.isRequired,
  campaignRelatedProducts: bool,
  onSuccess: func.isRequired,
  onDeleteCreative: func.isRequired,
  isLoading: bool.isRequired,
  campaignId: number,
  creative: creativeShape.isRequired,
  products: arrayOf(productWithRequirementShape).isRequired,
};

CreativeCompatibilityActions.defaultProps = {
  campaignRelatedProducts: false,
  campaignId: null,
};

export default CreativeCompatibilityActions;
